/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Change_WarningInputs */



/**
* | output |
* | --- |
* | "After saving, you will be logged out and will need to log in again with your new credentials" |
*
* @param {Email_Change_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const email_change_warning = /** @type {((inputs?: Email_Change_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Change_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("After saving, you will be logged out and will need to log in again with your new credentials")
	return /** @type {LocalizedString} */ ("Après enregistrement, vous serez déconnecté et vous devrez vous reconnecter avec vos nouveaux identifiants")
});